import {jsonMember, jsonObject} from "typedjson";
import {Observable} from "rxjs";


/** Описание кнопки модального окна. */
@jsonObject
export class DxModalButton {
  @jsonMember({name: "title", constructor: String, emitDefaultValue: false, isRequired: false})
  private _title: string;

  @jsonMember({name: "icon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _icon: string;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false})
  private _ord: number = 1;

  @jsonMember({name: "disabled", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _disabled: boolean = false;

  @jsonMember({constructor: Boolean, emitDefaultValue: false, isRequired: false})
  public visible: boolean = true;

  @jsonMember({name: "resultType", constructor: String, emitDefaultValue: false, isRequired: false})
  private _resultType: string;

  /**
   * button's callback which may be used for rest method invocation
   * and then doing or not of linear button action result
   */
  public handleCallback: () => boolean | Observable<boolean> | PromiseLike<boolean>;


  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  get resultType(): string {
    return this._resultType;
  }

  set resultType(value: string) {
    this._resultType = value;
  }


  constructor(fields?: Partial<DxModalButton>) {
    if (fields)
      Object.assign(this, fields);
  }
}
